import GraphQLClientService from '../../services/GraphQLClientService';
import { FlurstuckEntity } from "../../ResponseObjects/Schemas/FlurstuckEntity";
import { RiskAreaEntity } from '../../ResponseObjects/Schemas/RiskAreaEntity';
import { BPlanEntity } from '../../ResponseObjects/Schemas/BPlanEntity';
import { Stage,GeometryType } from '../../constants/progress';
import { useProgressStore } from '../../store/progressStore';

export default async function fetchBPlanData(minX, minY, maxX, maxY) {
  const updateProgress = useProgressStore.getState().updateProgress;
  const geometryType = GeometryType.BPLAN;
  // Validate parameters
  //console.log(minX,minY,maxX,maxY)
  if (minX === undefined || minY === undefined || maxX === undefined || maxY === undefined) {
    updateProgress(geometryType,{
      stage: Stage.ERROR,
      message: "Missing bounding box",
      error: "All boundary parameters (minX, minY, maxX, maxY) are required"
    });
    
    throw new Error('All boundary parameters (minX, minY, maxX, maxY) are required');
  }

   updateProgress(geometryType,
    {
      stage: Stage.QUERY,
      message:'Fetching data from server',
      progress: 25,
      error: null
    })
    console.log("progress updated")

  const query = `query DevelopmentPlanByBounds 
  {
    developmentPlanByBounds(
      minLat: ${maxY}
      minLon:${maxX}
      maxLat: ${minY}
      maxLon: ${minX}
      outputCRS: EPSG25832
      revitProtocol: true
    ) {
        developmentPlans {
            geometry
            landuse
            municipalityName
            municipalityKey
            status
            id
            objectId
            type
            url
            label
            isClipped
        }
    }
  }`;

  const client = new GraphQLClientService();

  try {
    const response = await client.executeQueryAsync(query);
    if (response == "TimedOUT")
    {
      updateProgress(geometryType,{
          stage: Stage.TIMEDOUT,
          message:"Timed out",
          progress:0
          
        })
      return null;

    }
    else{
      if (response.data.developmentPlanByBounds.developmentPlans.length > 0) {
          updateProgress(geometryType,{
            stage: Stage.QUERYSTAGE,
            message:"Fetched data from the server",
            progress:50,// need to change the progress
            fetched: response.data.developmentPlanByBounds.length
          })
      const bPlanEntities = BPlanEntity.fromResponse(response);
        updateProgress(geometryType,{
          stage: Stage.PROCESSINGSTAGE,
          message:"Processed fetched data from the server",
          progress:50,// need to change the progress
          processed: bPlanEntities.length
        })

      return bPlanEntities;
    } else {
      updateProgress(geometryType,{
        stage: Stage.NULL,
        message:"No data returned or an error occurred",
        progress:50,// need to change the progress
        
      })
      
      console.log('No data returned or an error occurred.');
      return null;
    }
    }
    
   
  } catch (error) {
      updateProgress(geometryType,{
        stage: Stage.ERROR,
        message:"Error during GraphQL request",
        progress:50,// need to change the progress
        
      })
    console.error('Error during GraphQL request:', error);
    throw error; 
  }
}